import React from 'react';

const GraphBackground = () => {
    return (
        <div className="fixed inset-0 pointer-events-none overflow-hidden opacity-30">
        {/* Single connected graph pattern */}
            <svg 
                className="absolute inset-0 w-full h-full" 
                viewBox="0 0 1200 800" 
                preserveAspectRatio="xMidYMid slice"
            >
                <defs>
                    <radialGradient id="nodeGradient" cx="50%" cy="50%" r="50%">
                        <stop offset="0%" stopColor="#066" stopOpacity="0.9" />
                        <stop offset="100%" stopColor="#066" stopOpacity="0.5" />
                    </radialGradient>
                </defs>
                
                {/* Edges/connections - single connected graph */}
                <g stroke="#066" strokeWidth="2" fill="none" opacity="0.8">
                    {/* From start node (top left) to first level (left side) */}
                    <path d="M 80 120 Q 100 180 120 240" strokeDasharray="3,4" />
                    <path d="M 80 120 Q 110 200 140 280" strokeDasharray="3,4" />
                    <path d="M 80 120 Q 120 160 160 200" strokeDasharray="3,4" />
                    
                    {/* From first level to second level (spreading to sides) */}
                    <path d="M 120 240 Q 180 280 240 320" strokeDasharray="3,4" />
                    <path d="M 120 240 Q 160 300 200 360" strokeDasharray="3,4" />
                    <path d="M 140 280 Q 200 320 260 360" strokeDasharray="3,4" />
                    <path d="M 140 280 Q 180 340 220 400" strokeDasharray="3,4" />
                    <path d="M 160 200 Q 220 240 280 280" strokeDasharray="3,4" />
                    <path d="M 160 200 Q 240 180 320 160" strokeDasharray="3,4" />
                    
                    {/* Branching to right side */}
                    <path d="M 280 280 Q 400 300 520 320" strokeDasharray="3,4" />
                    <path d="M 320 160 Q 460 140 600 120" strokeDasharray="3,4" />
                    <path d="M 240 320 Q 380 340 520 360" strokeDasharray="3,4" />
                    
                    {/* Right side spreading */}
                    <path d="M 520 320 Q 620 300 720 280" strokeDasharray="3,4" />
                    <path d="M 520 320 Q 640 340 760 360" strokeDasharray="3,4" />
                    <path d="M 600 120 Q 720 100 840 80" strokeDasharray="3,4" />
                    <path d="M 600 120 Q 740 140 880 160" strokeDasharray="3,4" />
                    <path d="M 520 360 Q 640 380 760 400" strokeDasharray="3,4" />
                    <path d="M 520 360 Q 620 420 720 480" strokeDasharray="3,4" />
                    
                    {/* Left side deeper branching */}
                    <path d="M 200 360 Q 160 420 120 480" strokeDasharray="3,4" />
                    <path d="M 220 400 Q 180 460 140 520" strokeDasharray="3,4" />
                    <path d="M 260 360 Q 220 440 180 520" strokeDasharray="3,4" />
                    
                    {/* Final endpoints on far right */}
                    <path d="M 720 280 Q 820 260 920 240" strokeDasharray="3,4" />
                    <path d="M 760 360 Q 860 340 960 320" strokeDasharray="3,4" />
                    <path d="M 840 80 Q 940 60 1040 40" strokeDasharray="3,4" />
                    <path d="M 880 160 Q 980 140 1080 120" strokeDasharray="3,4" />
                    <path d="M 760 400 Q 860 420 960 440" strokeDasharray="3,4" />
                    <path d="M 720 480 Q 820 500 920 520" strokeDasharray="3,4" />
                    
                    {/* Final endpoints on far left */}
                    <path d="M 120 480 Q 80 540 40 600" strokeDasharray="3,4" />
                    <path d="M 140 520 Q 100 580 60 640" strokeDasharray="3,4" />
                    <path d="M 180 520 Q 140 580 100 640" strokeDasharray="3,4" />
                    
                    {/* Bottom spreading */}
                    <path d="M 220 400 Q 320 460 420 520" strokeDasharray="3,4" />
                    <path d="M 420 520 Q 520 540 620 560" strokeDasharray="3,4" />
                    <path d="M 620 560 Q 720 580 820 600" strokeDasharray="3,4" />
                    
                    {/* Cross connections for complexity */}
                    <path d="M 240 320 Q 300 280 320 160" strokeDasharray="2,5" opacity="0.5" />
                    <path d="M 520 320 Q 480 280 520 360" strokeDasharray="2,5" opacity="0.5" />
                    </g>
                    
                    {/* Nodes - rounded rectangles */}
                    <g fill="url(#nodeGradient)">
                    {/* Start node (top left) */}
                    <rect x="60" y="105" width="40" height="30" rx="15" ry="15" />
                    
                    {/* First level (left side) */}
                    <rect x="105" y="225" width="35" height="25" rx="12" ry="12" />
                    <rect x="125" y="265" width="35" height="25" rx="12" ry="12" />
                    <rect x="145" y="185" width="35" height="25" rx="12" ry="12" />
                    
                    {/* Second level (spreading outward) */}
                    <rect x="225" y="305" width="30" height="20" rx="10" ry="10" />
                    <rect x="185" y="345" width="30" height="20" rx="10" ry="10" />
                    <rect x="245" y="345" width="30" height="20" rx="10" ry="10" />
                    <rect x="205" y="385" width="30" height="20" rx="10" ry="10" />
                    <rect x="265" y="265" width="30" height="20" rx="10" ry="10" />
                    <rect x="305" y="145" width="30" height="20" rx="10" ry="10" />
                    
                    {/* Right side nodes */}
                    <rect x="505" y="305" width="30" height="20" rx="10" ry="10" />
                    <rect x="585" y="105" width="30" height="20" rx="10" ry="10" />
                    <rect x="505" y="345" width="30" height="20" rx="10" ry="10" />
                    <rect x="705" y="265" width="30" height="20" rx="10" ry="10" />
                    <rect x="745" y="345" width="30" height="20" rx="10" ry="10" />
                    <rect x="825" y="65" width="30" height="20" rx="10" ry="10" />
                    <rect x="865" y="145" width="30" height="20" rx="10" ry="10" />
                    <rect x="745" y="385" width="30" height="20" rx="10" ry="10" />
                    <rect x="705" y="465" width="30" height="20" rx="10" ry="10" />
                    
                    {/* Left side deeper nodes */}
                    <rect x="105" y="465" width="30" height="20" rx="10" ry="10" />
                    <rect x="125" y="505" width="30" height="20" rx="10" ry="10" />
                    <rect x="165" y="505" width="30" height="20" rx="10" ry="10" />
                    
                    {/* Far right endpoints */}
                    <rect x="905" y="225" width="25" height="15" rx="7" ry="7" />
                    <rect x="945" y="305" width="25" height="15" rx="7" ry="7" />
                    <rect x="1025" y="25" width="25" height="15" rx="7" ry="7" />
                    <rect x="1065" y="105" width="25" height="15" rx="7" ry="7" />
                    <rect x="945" y="425" width="25" height="15" rx="7" ry="7" />
                    <rect x="905" y="505" width="25" height="15" rx="7" ry="7" />
                    
                    {/* Far left endpoints */}
                    <rect x="25" y="585" width="25" height="15" rx="7" ry="7" />
                    <rect x="45" y="625" width="25" height="15" rx="7" ry="7" />
                    <rect x="85" y="625" width="25" height="15" rx="7" ry="7" />
                    
                    {/* Bottom chain endpoints */}
                    <rect x="405" y="505" width="25" height="15" rx="7" ry="7" />
                    <rect x="605" y="545" width="25" height="15" rx="7" ry="7" />
                    <rect x="805" y="585" width="25" height="15" rx="7" ry="7" />
                </g>
            </svg>
        </div>
    );
};

export default GraphBackground;